import { logD, logE } from "@blacknut/logging/dist";
import { AppLayout, State } from "core";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { firstValueFrom } from "rxjs";
import { LOGGING_TAG } from "./Utils";
import { deriveToken } from "@blacknut/javascript-sdk/dist/api/deriveToken";

export const useWebAppURL = () => {
  const { familyToken, userToken, layout } = useSelector(
    (state: State) => state.globalState,
  );

  const create = useCallback(
    async (pathname: string, params?: Record<string, string>) => {
      const url = new URL(`${window.location.origin}${pathname}`);

      let _userToken = userToken;
      let _familyToken = familyToken;

      if (layout === AppLayout.TV) {
        try {
          const derived = await firstValueFrom(deriveToken("app_derived")); // can be set to whatever, but need to avoid setting it to "app", it will cause a disconnect on refreshToken
          _userToken = derived.userToken;
          _familyToken = derived.familyToken;
        } catch (e) {
          logE(LOGGING_TAG, "Caught error on token derivation", e);
        }
      }

      if (_familyToken) {
        url.searchParams.append("at", _familyToken.accessToken);
        url.searchParams.append("rt", _familyToken.refreshToken);
      }
      if (_userToken) {
        url.searchParams.append("uat", _userToken.accessToken);
        url.searchParams.append("urt", _userToken.refreshToken);
      }

      if (params) {
        const keys = Object.keys(params);
        for (const idx in keys) {
          url.searchParams.append(keys[idx], params[keys[idx]]);
        }
      }

      logD(LOGGING_TAG, "Using URL: %o", url.toString());
      return url;
    },
    [familyToken, layout, userToken],
  );
  return {
    create,
  };
};
